import { useState, useRef, useEffect, useCallback } from "react";
import { LANGUAGE_OPTIONS, LANGUAGES_WITH_STATIC_FILES } from "../../constants/config";
import styles from "./styles.module.scss";

const LanguageSelector = ({ currentLanguage, onChangeLanguage, setLoader }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLabel = currentLanguage?.toUpperCase() || "EN";

  const handleSelect = useCallback(
    (langCode) => {
      if (langCode !== currentLanguage) {
        const needsLoader = !LANGUAGES_WITH_STATIC_FILES.includes(langCode);

        if (needsLoader && setLoader) {
          setLoader(true);
        }

        onChangeLanguage(langCode);

        if (needsLoader && setLoader) {
          setTimeout(() => setLoader(false), 500);
        }
      }
      setIsOpen(false);
    },
    [currentLanguage, onChangeLanguage, setLoader]
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.containerSelector} ref={dropdownRef}>
      <button
        type="button"
        className={styles.languageButton}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-label="Select language"
      >
        <span>{currentLabel}</span>
        <svg
          className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ""}`}
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M2.5 4.5L6 8L9.5 4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {isOpen && (
        <div className={styles.dropdown} role="listbox">
          {LANGUAGE_OPTIONS.map((lang) => (
            <div
              key={lang.code}
              role="option"
              aria-selected={lang.code === currentLanguage}
              className={`${styles.option} ${
                lang.code === currentLanguage ? styles.active : ""
              }`}
              onClick={() => handleSelect(lang.code)}
            >
              <span>{lang.nativeName}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
